// LocaleChecker.tsx
import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { LOCALES } from "../constants/locales";
import { useLingui } from "@lingui/react";

function LocaleChecker() {
  const history = useHistory();
  const location = useLocation();
  const { i18n } = useLingui();

  useEffect(() => {
    // Check if locale is missing from URL
    const locale = i18n.locale ?? "it";
    const urlLocale = location.pathname.split("/")[1];
    if (!urlLocale || !LOCALES.includes(urlLocale)) {
      // Default locale
      const newPath = `/${locale}${location.pathname}${location.search}${location.hash}`;
      history.replace(newPath);
      return;
    }
  }, [history, location]);

  return null;
}

export default LocaleChecker;
